import { Box, Card, Grid, Typography } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { SERVER_URI } from "../../utils/config"

export const ContactRequests = () => {
	const [contactRequests, setContactRequests] = useState([])

	const getContactRequests = async () => {
		try {
			const response = await axios.get(`${SERVER_URI}/get_feedbacks`)
			const filteredRequests = response.data.feedbacks.filter((feedback) => feedback.message === "YHTEYDENOTTOPYYNTÖ")
			setContactRequests(filteredRequests)
		} catch (error) {
			console.error(error)
		}
	}

	useEffect(() => {
		getContactRequests()
	}, [])

	return (
		<Box
			sx={{
				justifyContent: "center",
				alignContent: "center",
				textAlign: "center",
			}}>
			<Grid container spacing={2} columns={4}>
				{contactRequests.map((item) => (
					<Grid item xs={1} key={item.feedbackid}>
						<Card elevation={3}>
							<Typography variant="h6">{item.name}</Typography>
							<Typography variant="h6">
								<a href={`mailto:${item.email}`}>{item.email}</a>
							</Typography>
						</Card>
					</Grid>
				))}
			</Grid>
		</Box>
	)
}
